var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivitySleepIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9849 17.8647C34.0127 26.6908 26.4122 32.5648 17.4489 33.6644C8.4856 34.764 1.5537 30.6728 0.525892 21.8467C-0.501915 13.0206 -0.912114 1.18244 8.05119 0.0828416C17.0145 -1.01675 31.9571 9.03857 32.9849 17.8647Z",
    fill: "#1E3269",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9666 8.50019C25.219 8.07647 24.9137 7.53918 24.4205 7.53918H20.5654C20.2143 7.53918 19.9297 7.82378 19.9297 8.17485V8.71979C19.9297 9.07087 20.2143 9.35546 20.5654 9.35546H22.343L20.2991 12.7864C20.0466 13.2101 20.352 13.7474 20.8452 13.7474H24.8438C25.1949 13.7474 25.4795 13.4628 25.4795 13.1117V12.5668C25.4795 12.2157 25.1949 11.9311 24.8438 11.9311H22.9227L24.9666 8.50019Z",
    fill: "#7E88BA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99988 16.6531C4.99988 22.5397 9.81402 27.33 15.7245 27.33C21.3727 27.33 26.0677 22.9448 26.449 17.3442C26.4729 17.0582 26.306 16.7722 26.0201 16.6531C25.7579 16.5339 25.4242 16.5816 25.2098 16.7961C23.8036 18.2022 22.0877 18.9648 20.3718 18.9648C16.5586 18.9648 13.4842 15.8666 13.4842 12.0773C13.4842 10.3375 14.2469 8.62156 15.653 7.21545C15.8675 7.00096 15.9151 6.69114 15.796 6.42898C15.6768 6.16683 15.3908 6 15.1048 6C9.43271 6.30982 4.99988 11.0048 4.99988 16.6531Z",
    fill: "#434C78"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivitySleepIcon);
export default __webpack_public_path__ + "static/media/activity-sleep-icon.83fa4113c97982a23be4f368702194d6.svg";
export { ForwardRef as ReactComponent };